import React from 'react';

interface SecurityConfigurationTileItemProps {
  title: string;
  value: string;
  icon: string;
  href: string;
}

export const SecurityConfigurationTileItem: React.FC<SecurityConfigurationTileItemProps> = ({
  title,
  value,
  icon,
  href,
}) => {
  const imgPath = `assets/images/${icon}.mono.svg`;
  const imgHoverPath = `assets/images/${icon}.svg`;

  return (
    <a href={href}>
      <div className="flex-auto flex-box-row security-configuration-item">
        <div className="flex-auto security-configuration-item__icon">
          <img src={imgPath} alt={title} />
          <img src={imgHoverPath} alt={title} className="alt" />
        </div>
        <div className="flex-one security-configuration-item__data">
          <div className="security-configuration-item__label">{title}</div>
          <div className="security-configuration-item__value">{value}</div>
        </div>
      </div>
    </a>
  );
};
